import React, { useState } from 'react';
import { SubcontractType } from '../../types';

interface SubcontractTypeManagerProps {
    types: SubcontractType[];
    setTypes: React.Dispatch<React.SetStateAction<SubcontractType[]>>;
}

const SubcontractTypeManager: React.FC<SubcontractTypeManagerProps> = ({ types, setTypes }) => {
    const [newTypeName, setNewTypeName] = useState('');

    const handleAddType = () => {
        if (!newTypeName.trim()) return;
        setTypes([...types, {
            id: `st-${Date.now()}`,
            name: newTypeName.trim()
        }]);
        setNewTypeName('');
    };

    const handleDeleteType = (typeId: string) => {
        if (confirm('¿Está seguro de eliminar este Tipo de Subcontrato Maestro?')) {
            setTypes(types.filter(t => t.id !== typeId));
        }
    };

    return (
        <div className="p-4 md:p-8 space-y-6 max-w-4xl mx-auto">
            <div className="bg-white dark:bg-[#1a2634] p-6 rounded-3xl border border-slate-200 dark:border-slate-800 shadow-sm">
                <div>
                    <h2 className="text-xl font-black text-slate-800 dark:text-white flex items-center gap-2">
                        <span className="material-symbols-outlined text-blue-500 text-[24px]">handshake</span>
                        Maestro de Tipos de Subcontrato
                    </h2>
                    <p className="text-sm text-slate-500 mt-2">Administre las modalidades de contratación disponibles para la plataforma (Ej: Suma Alzada, Serie de Precios Unitarios).</p>
                </div>
                
                <div className="flex flex-col md:flex-row gap-2 mt-6">
                    <input 
                        type="text" 
                        placeholder="Nuevo Tipo de Subcontrato" 
                        className="flex-1 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg px-4 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                        value={newTypeName}
                        onChange={(e) => setNewTypeName(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleAddType()}
                    />
                    <button 
                        onClick={handleAddType}
                        className="w-full md:w-auto bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-bold shadow hover:bg-blue-600 transition-colors"
                    >
                        Agregar Tipo
                    </button>
                </div>
            </div>

            <div className="bg-white dark:bg-[#1a2634] rounded-2xl border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="bg-slate-50 dark:bg-slate-900/50 border-b border-slate-200 dark:border-slate-800 text-slate-500 text-xs uppercase tracking-wider">
                            <th className="p-4 font-bold">Tipo de Subcontrato</th>
                            <th className="p-4 font-bold text-right">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {types.length === 0 ? (
                            <tr>
                                <td colSpan={2} className="p-8 text-center text-slate-400 text-sm">No hay tipos de subcontrato definidos.</td>
                            </tr>
                        ) : types.map(type => (
                            <tr key={type.id} className="border-b border-slate-100 dark:border-slate-800/50 hover:bg-slate-50 dark:hover:bg-slate-800/20 transition-colors">
                                <td className="p-4">
                                    <span className="font-medium text-slate-800 dark:text-slate-200">{type.name}</span>
                                </td>
                                <td className="p-4 text-right">
                                    <button 
                                        onClick={() => handleDeleteType(type.id)}
                                        className="text-slate-400 hover:text-red-500 p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
                                        title="Eliminar Tipo"
                                    >
                                        <span className="material-symbols-outlined text-[20px]">delete</span>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SubcontractTypeManager;
